import { useState, useCallback } from 'react';
import type { PlanFilter } from '@src/models/channel';

export function useChannelFilters() {
  // 실제 검색에 사용되는 값 (검색 버튼/엔터 시에만 업데이트)
  const [searchTerm, setSearchTermState] = useState('');
  // 사용자가 입력 중인 값 (실시간 업데이트)
  const [searchInput, setSearchInputState] = useState('');
  const [selectedPlan, setSelectedPlanState] = useState<PlanFilter>('all');

  // 검색 입력값 변경 (실시간)
  const setSearchInput = useCallback((value: string) => {
    if(value.length  === 0) {
      executeSearch();
    }
    setSearchInputState(value);
  }, []);

  // 실제 검색 실행 (검색 버튼/엔터 시)
  const executeSearch = useCallback(() => {

    setSearchTermState(searchInput);
  }, [searchInput]);

  const setSelectedPlan = useCallback((value: PlanFilter) => {
    setSelectedPlanState(value);
  }, []);

  const resetFilters = useCallback(() => {
    setSearchTermState('');
    setSearchInputState('');
    setSelectedPlanState('all');
  }, []);

  return {
    searchTerm, // API 쿼리에 사용
    searchInput, // UI 입력필드에 사용
    selectedPlan,
    setSearchInput,
    executeSearch,
    setSelectedPlan,
    resetFilters,
  };
}

